import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    /* min-height rather than height: on short viewports the content grows the page
       instead of overflowing a fixed-height box.
       Pages rendered beneath the fixed header override the variable to trim that
       header's height off, so the centring box matches the space actually visible. */
    min-height: var(--errors-layout-height, 100vh);
`;

const Root = styled.div`
    height: 100vh;
    overflow: hidden;
    position: relative;
    background: ${(props) => props.theme['Surface/page']}
        /* TODO: check color. Alternatives: ["Surface/page","Surface/primary","Content/inverse","Content/overlay"] */;
`;

const FirstCircle = styled.div`
    position: absolute;
    width: 1405px;
    height: 1405px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 2;
    background: #dafbf6 /* TODO: need to change color. There is no such color in themes.ts */;
    opacity: 0.1;
    border-radius: 50%;
    border: 4px solid #b5f7ed /* TODO: need to change color. There is no such color in themes.ts */;
`;

const FirstCircleInner = styled.div`
    position: absolute;
    width: 1381px;
    height: 1381px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 2;
    background: #dafbf6 /* TODO: need to change color. There is no such color in themes.ts */;
    opacity: 0.1;
    border-radius: 50%;
    border: 4px solid #b5f7ed /* TODO: need to change color. There is no such color in themes.ts */;
`;

const SecondCircle = styled.div`
    position: absolute;
    width: 1029px;
    height: 1029px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 3;
    border-radius: 50%;
    background: #dafbf6 /* TODO: need to change color. There is no such color in themes.ts */;
    opacity: 0.2;
    border: 4px solid #b5f7ed /* TODO: need to change color. There is no such color in themes.ts */;
`;
const SecondCircleInner = styled.div`
    position: absolute;
    width: 1012.01px;
    height: 1012.01px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 3;
    border-radius: 50%;
    background: #dafbf6 /* TODO: need to change color. There is no such color in themes.ts */;
    opacity: 0.2;
    border: 4px solid #b5f7ed /* TODO: need to change color. There is no such color in themes.ts */;
`;

const ThirdCircle = styled.div`
    position: absolute;
    width: 721px;
    height: 721px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 4;
    border-radius: 50%;
    background: ${(props) => props.theme['Surface/page']}
        /* TODO: check color. Alternatives: ["Surface/page","Surface/primary","Content/inverse","Content/overlay"] */;
    opacity: 0.4;
    border: 4px solid #dafbf6 /* TODO: need to change color. There is no such color in themes.ts */;
`;

const ThirdCircleInner = styled.div`
    position: absolute;
    width: 703px;
    height: 703px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 4;
    border-radius: 50%;
    background: ${(props) => props.theme['Surface/page']}
        /* TODO: check color. Alternatives: ["Surface/page","Surface/primary","Content/inverse","Content/overlay"] */;
    opacity: 0.4;
    border: 4px solid #dafbf6 /* TODO: need to change color. There is no such color in themes.ts */;
`;

const ErrorContent = styled.div`
    position: absolute;
    width: 703px;
    height: 703px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 5;
    justify-content: center;
    align-items: center;
    display: flex;
    min-height: 100%;
`;

const ErrorsLayout: React.FC<{
    children: React.ReactNode;
}> = ({ children }) => {
    return <Container>{children}</Container>;
};

export default ErrorsLayout;
